import React from 'react';
import { IMaskInput } from 'react-imask';

/**
 * Um componente genérico para inputs com máscara.
 * Ele abstrai a complexidade do IMaskInput.
 */
const MaskedInput = React.forwardRef(function MaskedInput(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export const CnpjMaskCustom = React.forwardRef((props, ref) => (
  <MaskedInput {...props} mask="00.000.000/0000-00" ref={ref} />
));
export const CepMaskCustom = React.forwardRef((props, ref) => (
  <MaskedInput {...props} mask="00000-000" ref={ref} />
));

export const IEMaskCustom = React.forwardRef(function IEMaskCustom(props, ref) {
  const { uf, ...other } = props;

  const getIEMask = (state) => {
    // Máscaras alinhadas com a biblioteca 'js-brasil' para consistência na validação.
    const masks = {
      AC: '00.000.000/000-00',
      AL: '000000000',
      AP: '000000000',
      AM: '00.000.000-0',
      BA: '000000-00', // Nota: js-brasil tem lógica para 8 ou 9 dígitos, a máscara simples é para 8.
      CE: '00000000-0',
      DF: '00000000000-00',
      ES: '00000000-0',
      GO: '00.000.000-0',
      MA: '000000000',
      MG: '000.000.000/0000',
      MS: '000000000',
      MT: '0000000000-0',
      PA: '00-000000-0',
      PB: '00000000-0',
      PR: '000.00000-00',
      PE: '0000000-00', // Corrigido para o formato mais comum
      PI: '000000000',
      RJ: '00.000.00-0',
      RN: '00.0.000.000-0', // Nota: js-brasil tem lógica para 9 ou 10 dígitos.
      RS: '000/0000000',
      RO: '0000000000000-0',
      RR: '00000000-0',
      SC: '000.000.000',
      SP: '000.000.000.000', // Para "P", a lógica é mais complexa, mas a máscara numérica é esta.
      SE: '00000000-0',
      TO: '00000000000',
    };
    return masks[state] || '';
  };

  const mask = getIEMask(uf);
  return (
    <MaskedInput {...other} mask={mask} ref={ref} />
  );
});
